import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class PodrucjeznanjaPopisService {

  constructor(private _http: Http) { }

  dohvatiSve(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_sva_podrucjaznanja', a)
    .map(res => res.json());
  }

  dodajPodrucjeznanja(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'spremi_podrucjeznanja', a)
    .map(res => res.json());
  }

  urediPodrucjeznanja(a: any){
    return this._http.put(AppConfig.apiAdresaSQL + 'uredi_podrucjeznanja', a)
    .map(res => res.json());
  }

  obrisiPodrucjeznanja(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'obrisi_podrucjeznanja', a)
    .map(res => res.json());
  }


}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/podrucjeznanja-popis/podrucjeznanja-popis.service.ts